import {
    SimplePresentation
} from "../../core/winpresentation/SimplePresentationRunner";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DevilsCrossRoadGameMode} from "../server/DevilsCrossRoadGameMode";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";


export class WinSummary implements SimplePresentation {
    name: string = "WinSummary";

    private isFreespinEnd:boolean;

    constructor(isFreespinEnd:boolean = true) {
        this.isFreespinEnd = isFreespinEnd;
    }


    shouldRun(): boolean {

       const belowWinStake:boolean = BelowStakeWinRestriction.isWinBelowStake();
       if(belowWinStake) {
           return false;
       }

        return (DevilsCrossRoad.model.data.mode == GameMode.FREESPIN && DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.NORMAL)
            || (DevilsCrossRoad.model.data.mode == DevilsCrossRoadGameMode.SUPER_FREESPIN && DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.NORMAL);
    }

    public async start(flowStateController:FlowStateController) {
        await DevilsCrossRoad.endBonusWinPresentations.startInLine(flowStateController);
        flowStateController.finish();
    }

}